import React, { useEffect } from 'react';
import { UtilityBar } from '../components/UtilityBar';
import { SiteHeader } from '../components/SiteHeader/SiteHeader';
import { HeroSection } from '../components/HeroSection';
import { TrustStrip } from '../components/TrustStrip';
import { ServicesSection } from '../components/ServicesSection';
import { WorkGallery } from '../components/WorkGallery';
import { FleetSection } from '../components/FleetSection';
import { ProcessSection } from '../components/ProcessSection';
import { AboutSection } from '../components/AboutSection';
import { FaqSection } from '../components/FaqSection';
import { ContactSection } from '../components/ContactSection';
import { SiteFooter } from '../components/SiteFooter';
export function Home() {
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash || hash === '#top') return;
    const timer = window.setTimeout(() => {
      document.querySelector(hash)?.scrollIntoView({
        block: 'start'
      });
    }, 80);
    return () => window.clearTimeout(timer);
  }, []);
  return <div id="top" className="min-h-screen w-full bg-paper font-sans text-ink" data-id="element-498" data-mp="30w03nygchg2z">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-ink focus:px-4 focus:py-3 focus:text-paper" data-id="element-499" data-mp="2vyzw1j3uk59r">
        Skip to content
      </a>
      <UtilityBar data-id="element-500" data-mp="2mwqlwuchqdww" />
      <SiteHeader data-id="element-501" data-mp="2hxxad7grkwzd" />
      <main id="main" data-id="element-502" data-mp="2hyff6shhsjiw">
        <HeroSection data-id="element-503" data-mp="2hyywc6zbj3vv" />
        <TrustStrip data-id="element-504" data-mp="2hz8dr66as2py" />
        <ServicesSection data-id="element-505" data-mp="2hzqk4vmobxbl" />
        <FleetSection data-id="element-506" data-mp="2d6p0ybffpbm7" />
        <WorkGallery data-id="element-507" data-mp="2d65rlj3unvjs" />
        <ProcessSection data-id="element-508" data-mp="2d5w2dxqmpsf5" />
        <AboutSection data-id="element-509" data-mp="2d5dw08a95xti" />
        <FaqSection data-id="element-510" data-mp="287krrksifdvv" />
        <ContactSection data-id="element-511" data-mp="2895lj8702sso" />
      </main>
      <SiteFooter data-id="element-512" data-mp="2861d1ymi5aw7" />
    </div>;
}